<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M2.7129149999999997,3.9578266666793827C2.183923,3.799126666679382,1.883739,3.241646666679382,2.042437,2.712651666679382C2.201135,2.1836596666793824,2.7586180000000002,1.8834756666793824,3.28761,2.0421736666793824C3.28761,2.0421736666793824,13.2876,5.042176666679382,13.2876,5.042176666679382C14.2378,5.327236666679383,14.2378,6.672766666679382,13.2876,6.957826666679383C13.2876,6.957826666679383,3.28761,9.957826666679383,3.28761,9.957826666679383C2.7586180000000002,10.116526666679382,2.201135,9.816336666679383,2.042437,9.287346666679383C1.883739,8.758356666679383,2.183923,8.200876666679381,2.7129149999999997,8.042176666679381C2.7129149999999997,8.042176666679381,9.52016,5.999996666679382,9.52016,5.999996666679382C9.52016,5.999996666679382,2.7129149999999997,3.9578266666793827,2.7129149999999997,3.9578266666793827C2.7129149999999997,3.9578266666793827,2.7129149999999997,3.9578266666793827,2.7129149999999997,3.9578266666793827ZM3.00026,12.000036666679382C3.00026,12.000036666679382,13.0003,12.000036666679382,13.0003,12.000036666679382C13.5525,12.000036666679382,14.0003,12.447736666679383,14.0003,13.000036666679382C14.0003,13.552236666679383,13.5525,14.000036666679382,13.0003,14.000036666679382C13.0003,14.000036666679382,3.00026,14.000036666679382,3.00026,14.000036666679382C2.447978,14.000036666679382,2.000263304,13.552236666679383,2.000263304,13.000036666679382C2.000263304,12.447736666679383,2.447978,12.000036666679382,3.00026,12.000036666679382C3.00026,12.000036666679382,3.00026,12.000036666679382,3.00026,12.000036666679382Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'GreaterThanOrEqualTo',
} as DefineComponent
</script>
